module.exports = __webpack_public_path__ + "static/media/registration-footer.d26f040b.png";